
import exploreResultsDefault from '../components/blocks/exploreResultsDefault.vue';

export default {
  components: { exploreResultsDefault },

  methods:{
    init(){
 
        
    }
  },
  mounted(){
   // this.init()
  },
  data()  
	{
		return {
		hero: 
		{
			additionalClasses: "bg-gradient-green-white",
			h1 : "Search results"
		}				 
		};
	}
    
}
